import Theme from '../theme';

/**
 * Create the action
 */

const { thunk, request, success, error } = Theme.update((data, fetch) => {
  if (data.editPublicStatus === true) {
    return fetch.post(`/theme-set-public-status/${data.id}`, data);
  }

  // Prepare request
  const formData = new FormData();
  formData.append('_method', 'PUT');

  Object.keys(data).map(function (key) {
    if (key == 'image') {
      if (data[key].constructor === File) {
        formData.append(key, data[key]);
      } else if (data[key] === null) {
      }
    } else if (key == 'public') {
      formData.append(key, data[key] == false ? 0 : 1);
    } else if (key == 'categories') {
      formData.append(key, JSON.stringify(data[key]));
    } else {
      formData.append(key, data[key]);
    }
  });

  return fetch.post(`/themes/${data.id}`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
